module.exports = __webpack_public_path__ + "static/media/KDAA2_1.6a17fe25.png";